import React, { useEffect } from "react";
import {
  BootstrapTable,
  TableHeaderColumn,
  ClearSearchButton,
} from "react-bootstrap-table";
import ActionsInvestisseurTableData from "./ActionsInvestisseurTableData";
import ActionsInvestisseurTableSkeleton from "./ActionsInvestisseurTableSkeleton";
import Pdf from '../../../../images/pdf.png'

const ActionsInvestisseurTable = (props) => {
    
  var [isPageLoading, setIsPageLoading] = React.useState(true);
  // eslint-disable-next-line
  var [actions, setActions] = React.useState(ActionsInvestisseurTableData);

  useEffect(() => {
    setTimeout(() => {
      setIsPageLoading(false);
    }, 7000);
  }, [actions]);

  var handleClearButtonClick = (onClick) => {
    console.log("This is my custom function for ClearSearchButton click event");
    onClick();
  };

  var createCustomClearButton = (onClick) => {
    return (
      <ClearSearchButton
        btnText="Effacer"
        btnContextual="btn-warning"
        className="my-custom-class"
        onClick={(e) => handleClearButtonClick(onClick)}
      />
    );
  };

  const options = {
    clearSearch: true,
    clearSearchBtn: createCustomClearButton,
    noDataText: "Aucune donnée disponible",
  };

  const pdfFormatter = () => {
    return (
      <>
        <img src={Pdf} alt="PDF" className="pdf-img" />
      </>
    );
  };



  return (
    <div className="child-table-container">
      <div className="table-body-container border-none">
        <div className="row easypm-table-row m-t-50 m-b-50">
          <div className="col-md-12 easypm-table-col">
            {isPageLoading && <ActionsInvestisseurTableSkeleton />}
            {!isPageLoading && (
              <div className="table-container">
                <BootstrapTable
                  data={actions}
                  striped={true}
                  hover={true}
                  condensed={false}
                  multiColumnSort={2}
                  options={options}
                  search={false}
                  version="4"
                  bordered={false}
                >
                  <TableHeaderColumn
                    dataField="id"
                    isKey
                    hidden="true"
                    className="data-center-table-info"
                  ></TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="id"
                    className="data-center-table-info"
                  >
                    N
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="projet"
                    className="data-center-table-info"
                  >
                    Projet
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="nombre_action"
                    className="data-center-table-info"
                  >
                    Nombre d'actions
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="id"
                    dataFormat={(cell) => pdfFormatter(cell)}
                  >
                    PDF
                  </TableHeaderColumn>
                </BootstrapTable>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActionsInvestisseurTable;
